import { stat } from '@remote/utils/stat'

export default {
  install: (app, options) => {
    app.config.globalProperties.$stat = data => {
      stat(data)
    }
    app.provide('stat', options)
  },
}